//Creamos la variable de enumeraciones
const enumeraciones = {};


//Asignamos los datos necesarios del enumeraciones
enumeraciones.areas = {  
  JuzgadoDeEjecucionDePenasYMedidasDeSeguridad: 95 
}

enumeraciones.tiposDocumento = {  
  ExpedientePrincipal: 1,
  Terceria: 2,
  Promocion: 3,
  Amparo: 4,
  Exhorto: 5,
  Incidente: 10
}

enumeraciones.tiposPersonas = {  
  Autoridad: 1,
  Fisica: 2,
  Moral: 3 
}

enumeraciones.entidadesFederativas = {  
  Aguascalientes: 1,
  BajaCalifornia: 2,
  BajaCaliforniaSur: 3
}

//Exportamos los datos de enumeraciones
export default enumeraciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/enumeraciones/pj.js
// module id = null
// module chunks = 